module.exports = __webpack_public_path__ + "media/ring.7eec71da.mp3";